// Webhooks Events resend button
export const WEBHOOKS_EVENTS_RESEND_SUCCESS = 'webhooks_events_resend_success'
export const WEBHOOKS_EVENTS_RESEND_ERROR = 'webhooks_events_resend_error'

// General/Shared event names
export const SELLER_INVITATION_ACTION = 'seller_invitation_action'
export const API_LOAD_EVENT = 'api_load_event'
export const APPLICATIONS_CREATE_BTCRED_PAGE_LOAD =
  'applications_create_btcred_page_load'
export const NOTIFICATIONS_PAGE_LOAD = 'notifications_page_load'
export const NOTIFICATIONS_SEARCH = 'notifications_search'
export const CREATE_CUSTOM_ACCOUNT_VALIDATE_EMAIL =
  'create_custom_account_validate_email'
export const CREATE_CUSTOM_ACCOUNT_SUBMIT = 'create_custom_account_submit'
export const CREATE_ACCOUNT_SUBMIT = 'create_account_submit'
export const EDIT_ACCOUNT_PROPERTIES = 'edit_account_properties'

// API Webhook Factory events
export const ADD_WEBHOOK_SUCCESS = 'add_webhook_success'
export const ADD_WEBHOOK_ERROR = 'add_webhook_error'
export const EDIT_WEBHOOK_SUCCESS = 'edit_webhook_success'
export const EDIT_WEBHOOK_ERROR = 'edit_webhook_error'
export const DELETE_WEBHOOK_SUCCESS = 'delete_webhook_success'
export const DELETE_WEBHOOK_ERROR = 'delete_webhook_error'
export const GET_WEBHOOK_EVENTS_SUCCESS = 'get_webhook_events_success'
export const GET_WEBHOOK_EVENTS_ERROR = 'get_webhook_events_error'
export const GET_WEBHOOK_EVENTS_BY_FILTERS_SUCCESS =
  'get_webhook_events_by_filters_success'
export const GET_WEBHOOK_EVENTS_BY_FILTERS_ERROR =
  'get_webhook_events_by_filters_error'
export const GET_WEBHOOK_DETAILS_SUCCESS = 'get_webhook_details_success'
export const GET_WEBHOOK_DETAILS_ERROR = 'get_webhook_details_error'
export const RESEND_WEBHOOK_SUCCESS = 'resend_webhook_success'
export const RESEND_WEBHOOK_ERROR = 'resend_webhook_error'

// API Factory events
export const LOAD_ALL_APP_DATA_SUCCESS = 'load_all_app_data_success'
export const LOAD_ALL_APP_DATA_ERROR = 'load_all_app_data_error'
export const LOAD_ALL_ACCOUNT_SUCCESS = 'load_all_account_success'
export const LOAD_ALL_ACCOUNT_ERROR = 'load_all_account_error'
export const LOAD_ACCOUNT_DETAILS_SUCCESS = 'load_account_details_success'
export const LOAD_ACCOUNT_DETAILS_ERROR = 'load_account_details_error'
export const LOAD_APPS_CREDENTIAL_USING_CLIENT_ID_SUCCESS =
  'load_apps_credential_using_client_id_success'
export const LOAD_APPS_CREDENTIAL_USING_CLIENT_ID_ERROR =
  'load_apps_credential_using_client_id_error'
export const LOAD_CREDIT_CARD_DETAILS_SUCCESS =
  'load_credit_card_details_success'
export const LOAD_CREDIT_CARD_DETAILS_ERROR = 'load_credit_card_details_error'
export const LOAD_APPS_CREDENTIAL_USING_ACCOUNT_NUMBER_SUCCESS =
  'load_apps_credential_using_account_number_success'
export const LOAD_APPS_CREDENTIAL_USING_ACCOUNT_NUMBER_ERROR =
  'load_apps_credential_using_account_number_error'
export const LOAD_RECENT_TRANSACTIONS_SUCCESS =
  'load_recent_transactions_success'
export const LOAD_RECENT_TRANSACTIONS_ERROR = 'load_recent_transactions_error'
export const LOAD_API_ERROR_DETAILS_SUCCESS = 'load_api_error_details_success'
export const LOAD_API_ERROR_DETAILS_ERROR = 'load_api_error_details_error'
export const LOAD_WEBHOOK_ERROR_DETAILS_SUCCESS =
  'load_webhook_error_details_success'
export const LOAD_WEBHOOK_ERROR_DETAILS_ERROR =
  'load_webhook_error_details_error'
export const LOAD_API_WEBHOOK_ERROR_DETAIL_SUCCESS =
  'load_api_webhook_error_detail_success'
export const LOAD_API_WEBHOOK_ERROR_DETAIL_ERROR =
  'load_api_webhook_error_detail_error'
export const LOAD_API_WEBHOOK_ATTEMPT_HISTORY_SUCCESS =
  'load_api_webhook_attempt_history_success'
export const LOAD_API_WEBHOOK_ATTEMPT_HISTORY_ERROR =
  'load_api_webhook_attempt_history_error'
export const LOAD_SANDBOX_APP_DATA_SUCCESS = 'load_sandbox_app_data_success'
export const LOAD_SANDBOX_APP_DATA_ERROR = 'load_sandbox_app_data_error'
export const LOAD_API_CALLS_DETAIL_SUCCESS = 'load_api_calls_detail_success'
export const LOAD_API_CALLS_DETAIL_ERROR = 'load_api_calls_detail_error'
export const GET_USER_PREFERENCES_SUCCESS = 'get_user_preferences_success'
export const GET_USER_PREFERENCES_ERROR = 'get_user_preferences_error'
export const ADD_USER_PREFERENCE_SUCCESS = 'add_user_preference_success'
export const ADD_USER_PREFERENCE_ERROR = 'add_user_preference_error'
export const API_CRED_GENERATE_SECRET_SUCCESS =
  'api_cred_generate_secret_success'
export const API_CRED_GENERATE_SECRET_ERROR = 'api_cred_generate_secret_error'
export const API_CRED_DELETE_SECRET_SUCCESS = 'api_cred_delete_secret_success'
export const API_CRED_DELETE_SECRET_ERROR = 'api_cred_delete_secret_error'
export const API_CRED_TOGGLE_SECRET_SUCCESS = 'api_cred_toggle_secret_success'
export const API_CRED_TOGGLE_SECRET_ERROR = 'api_cred_toggle_secret_error'
export const SEND_UNAUTH_EMAIL_SUCCESS = 'send_unauth_email_success'
export const SEND_UNAUTH_EMAIL_ERROR = 'send_unauth_email_error'
export const GET_SELLER_INVITATION_SUCCESS = 'get_seller_invitation_success'
export const GET_SELLER_INVITATION_ERROR = 'get_seller_invitation_error'
export const GET_LIVE_PAYLOAD_DATA_SUCCESS = 'get_live_payload_data_success'
export const GET_LIVE_PAYLOAD_DATA_ERROR = 'get_live_payload_data_error'
export const GET_NOTIFICATIONS_SUCCESS = 'get_notifications_success'
export const GET_NOTIFICATIONS_ERROR = 'get_notifications_error'
export const UPDATE_NOTIFICATIONS_SUCCESS = 'update_notifications_success'
export const UPDATE_NOTIFICATIONS_ERROR = 'update_notifications_error'

// API App Factory events
export const APP_CREATE_API_SUCCESS = 'app_create_api_success'
export const APP_CREATE_API_ERROR = 'app_create_api_error'
export const APP_SETTINGS_SAVE_API_SUCCESS = 'app_settings_save_api_success'
export const APP_SETTINGS_SAVE_API_ERROR = 'app_settings_save_api_error'
export const APPLE_PAY_ADD_DOMAIN_API_SUCCESS =
  'apple_pay_add_domain_api_success'
export const APPLE_PAY_ADD_DOMAIN_API_ERROR = 'apple_pay_add_domain_api_error'
export const APP_DELETE_API_SUCCESS = 'app_delete_api_success'
export const APP_DELETE_API_ERROR = 'app_delete_api_error'
export const BT_CREDENTIALS_CREATE_API_SUCCESS =
  'bt_credentials_create_api_success'
export const BT_CREDENTIALS_CREATE_API_ERROR = 'bt_credentials_create_api_error'
export const IC_PLUS_CURRENCY_UPDATE_API_SUCCESS =
  'ic_plus_currency_update_api_success'
export const IC_PLUS_CURRENCY_UPDATE_API_ERROR =
  'ic_plus_currency_update_api_error'
export const IC_PLUS_CURRENCIES_FETCH_API_SUCCESS =
  'ic_plus_currencies_fetch_api_success'
export const IC_PLUS_CURRENCIES_FETCH_API_ERROR =
  'ic_plus_currencies_fetch_api_error'

// API Account Factory events
export const ACCOUNT_DETAILS_API_LOAD_SUCCESS =
  'account_details_api_load_success'
export const ACCOUNT_DETAILS_API_LOAD_ERROR = 'account_details_api_load_error'
export const DELETE_ACCOUNT_API_SUCCESS = 'delete_account_api_success'
export const DELETE_ACCOUNT_API_ERROR = 'delete_account_api_error'
export const ACCOUNT_DATA_BY_PAGE_API_SUCCESS =
  'account_data_by_page_api_success'
export const ACCOUNT_DATA_BY_PAGE_API_ERROR = 'account_data_by_page_api_error'
export const CREATE_SIMPLIFIED_ACCOUNT_API_SUCCESS =
  'create_simplified_account_api_success'
export const CREATE_SIMPLIFIED_ACCOUNT_API_ERROR =
  'create_simplified_account_api_error'
export const CREATE_CUSTOM_ACCOUNT_API_SUCCESS =
  'create_custom_account_api_success'
export const CREATE_CUSTOM_ACCOUNT_API_ERROR = 'create_custom_account_api_error'
export const CREATE_BULK_ACCOUNTS_API_SUCCESS =
  'create_bulk_accounts_api_success'
export const CREATE_BULK_ACCOUNTS_API_ERROR = 'create_bulk_accounts_api_error'
export const EDIT_ACCOUNT_API_SUCCESS = 'edit_account_api_success'
export const EDIT_ACCOUNT_API_ERROR = 'edit_account_api_error'

// Webhooks Events module
export const WEBHOOKS_EVENTS_PAGE_LOAD_SUCCESS =
  'webhooks_events_page_load_success'
export const WEBHOOKS_EVENTS_PAGE_LOAD_ERROR = 'webhooks_events_page_load_error'
export const WEBHOOKS_EVENTS_SUBMIT_SUCCESS = 'webhooks_events_submit_success'
export const WEBHOOKS_EVENTS_SUBMIT_ERROR = 'webhooks_events_submit_error'
export const WEBHOOKS_EVENTS_SHOW_DETAIL_SUCCESS =
  'webhooks_events_show_detail_success'
export const WEBHOOKS_EVENTS_SHOW_DETAIL_ERROR =
  'webhooks_events_show_detail_error'

// Transactions module
export const TRANSACTIONS_PAGE_LOAD = 'transactions_page_load'
export const WEBLLS_TRANSACTIONS_PAGE_LOAD = 'weblls_transactions_page_load'

// Sandbox Account module
export const SANDBOX_ACCOUNT_FETCH_MORE_RECORDS_SUCCESS =
  'sandbox_account_fetch_more_records_success'
export const SANDBOX_ACCOUNT_FETCH_MORE_RECORDS_ERROR =
  'sandbox_account_fetch_more_records_error'
export const SANDBOX_ACCOUNT_DUPLICATE_PAGE_LOAD_SUCCESS =
  'sandbox_account_duplicate_page_load_success'
export const SANDBOX_ACCOUNT_DUPLICATE_PAGE_LOAD_ERROR =
  'sandbox_account_duplicate_page_load_error'
export const SANDBOX_ACCOUNT_DUPLICATE_FORM_SUBMIT_SUCCESS =
  'sandbox_account_duplicate_form_submit_success'
export const SANDBOX_ACCOUNT_DUPLICATE_FORM_SUBMIT_ERROR =
  'sandbox_account_duplicate_form_submit_error'
export const SANDBOX_ACCOUNT_DELETE_SUCCESS = 'sandbox_account_delete_success'
export const SANDBOX_ACCOUNT_DELETE_ERROR = 'sandbox_account_delete_error'
export const SANDBOX_ACCOUNT_UPGRADE_PRO_SUCCESS =
  'sandbox_account_upgrade_pro_success'
export const SANDBOX_ACCOUNT_UPGRADE_PRO_ERROR =
  'sandbox_account_upgrade_pro_error'
export const SANDBOX_ACCOUNT_EDIT_PASSWORD_SUCCESS =
  'sandbox_account_edit_password_success'
export const SANDBOX_ACCOUNT_EDIT_PASSWORD_ERROR =
  'sandbox_account_edit_password_error'
export const SANDBOX_ACCOUNT_VALIDATE_PRIMARY_EMAIL_SUCCESS =
  'sandbox_account_validate_primary_email_success'
export const SANDBOX_ACCOUNT_VALIDATE_PRIMARY_EMAIL_ERROR =
  'sandbox_account_validate_primary_email_error'
export const SANDBOX_ACCOUNT_EDIT_EMAIL_SUCCESS =
  'sandbox_account_edit_email_success'
export const SANDBOX_ACCOUNT_EDIT_EMAIL_ERROR =
  'sandbox_account_edit_email_error'
export const SANDBOX_ACCOUNT_DELETE_CREDIT_CARD_SUCCESS =
  'sandbox_account_delete_credit_card_success'
export const SANDBOX_ACCOUNT_DELETE_CREDIT_CARD_ERROR =
  'sandbox_account_delete_credit_card_error'
export const SANDBOX_ACCOUNT_ADD_BANK_SUCCESS =
  'sandbox_account_add_bank_success'
export const SANDBOX_ACCOUNT_ADD_BANK_ERROR = 'sandbox_account_add_bank_error'
export const SANDBOX_ACCOUNT_DELETE_BANK_SUCCESS =
  'sandbox_account_delete_bank_success'
export const SANDBOX_ACCOUNT_DELETE_BANK_ERROR =
  'sandbox_account_delete_bank_error'
export const APPLICATIONS_EDIT_SANDBOX_ACCOUNT_INFO_ERROR =
  'applications_edit_sandbox_account_info_error'
export const SANDBOX_ACCOUNT_ADD_CREDIT_CARD_SUCCESS =
  'sandbox_account_add_credit_card_success'
export const SANDBOX_ACCOUNT_ADD_CREDIT_CARD_ERROR =
  'sandbox_account_add_credit_card_error'
export const SANDBOX_ACCOUNT_EDIT_FUNDING_PATCH =
  'sandbox_account_edit_funding_patch'
export const SANDBOX_ACCOUNT_BULK_UPLOAD_SUCCESS =
  'sandbox_account_bulk_upload_success'
export const SANDBOX_ACCOUNT_BULK_UPLOAD_ERROR =
  'sandbox_account_bulk_upload_error'
export const SANDBOX_ACCOUNT_PAGE_LOAD = 'sandbox_account_page_load'
export const SANDBOX_ACCOUNT_FETCH_ACCOUNTS_SUCCESS =
  'sandbox_account_fetch_accounts_success'
export const SANDBOX_ACCOUNT_FETCH_ACCOUNTS_ERROR =
  'sandbox_account_fetch_accounts_error'

// Applications module
export const WEBLLS_APPLICATIONS_EDIT_PAGE_LOAD =
  'weblls_applications_edit_page_load'
export const APPLICATIONS_EDIT_PAGE_LOAD = 'applications_edit_page_load'
export const APPLICATIONS_EDIT_PAGE_LOAD_ERROR =
  'applications_edit_page_load_error'
export const ACCOUNT_STATUS_PAGE_LOAD = 'account_status_page_load'
export const CREATE_APP_PAGE_LOAD = 'create_app_page_load'
export const CREATE_APP_SUBMIT = 'create_app_submit'
export const CREATE_APP_ERROR = 'create_app_error'
export const WEBLLS_APPLICATIONS_CREATE_PAGE_LOAD =
  'weblls_applications_create_page_load'
export const APPLICATIONS_CREATE_PAGE_LOAD = 'applications_create_page_load'
export const APPLICATIONS_CREATE_SUBMIT = 'applications_create_submit'
export const APPLICATIONS_CREATE_ERROR = 'applications_create_error'
export const APPLICATIONS_CREATE_BTCRED_GENERATE =
  'applications_create_btcred_generate'
export const APPLICATIONS_EDIT_SANDBOX_ACCOUNT_INFO_LOAD =
  'applications_edit_sandbox_account_info_load'
export const APPLICATIONS_EDIT_APP_NAME = 'applications_edit_app_name'
export const APPLICATIONS_EDIT_APP_SETTINGS = 'applications_edit_app_settings'
export const APPLICATIONS_EDIT_DELETE_WEBHOOK =
  'applications_edit_delete_webhook'
export const APPLICATIONS_EDIT_WEBHOOK_EDIT = 'applications_edit_webhook_edit'
export const APPLICATIONS_EDIT_WEBHOOK_ADD = 'applications_edit_webhook_add'
export const APPLICATIONS_EDIT_WEBHOOKS_LOAD = 'applications_edit_webhooks_load'
export const APPLICATIONS_EDITBTCRED_PAGE_LOAD =
  'applications_editbtcred_page_load'
export const APPLICATIONS_EDITBTCRED_ADD_CURRENCIES =
  'applications_editbtcred_add_currencies'
export const APPLICATIONS_EDITBTCRED_REFRESH_TOKEN =
  'applications_editbtcred_refresh_token'
export const APPLICATIONS_ECVIABTSDK_LOAD_BTCRED =
  'applications_ecviabtsdk_load_btcred'
export const APPLICATIONS_OPENID_MIGRATE = 'applications_openid_migrate'
export const APPLICATIONS_NVPSOAP_MANAGE_WEBHOOKS =
  'applications_nvpsoap_manage_webhooks'
export const APPLICATIONS_REST_APPS_DELETE = 'applications_rest_apps_delete'

// Dashboard module
export const DASHBOARD_API_CALLS_PAGE_LOAD = 'dashboard_api_calls_page_load'
export const DASHBOARD_API_CALLS_GET_DETAIL = 'dashboard_api_calls_get_detail'
export const DASHBOARD_API_CALLS_SUBMIT = 'dashboard_api_calls_submit'

// Home module
export const HOME_RECENT_TRANSACTIONS_GET_DETAIL =
  'home_recent_transactions_get_detail'
export const ONBOARDING_BANNER_LOAD_LIVE_APP = 'onboarding_banner_load_live_app'
export const HOME_ERROR_LOG_GET_DETAIL = 'home_error_log_get_detail'

// IPN Simulator module
export const IPN_SIMULATOR_PAGE_LOAD = 'ipn_simulator_page_load'
export const IPN_SIMULATOR_SEND_IPN = 'ipn_simulator_send_ipn'

// Mock modules
export const MOCK_CREDIT_CARD_GENERATOR_PAGE_LOAD =
  'mock_credit_card_generator_page_load'
export const MOCK_CREDIT_CARD_GENERATOR_GENERATE =
  'mock_credit_card_generator_generate'
export const MOCK_WEBHOOK_SIMULATOR_PAGE_LOAD =
  'mock_webhook_simulator_page_load'
export const MOCK_WEBHOOK_SIMULATOR_TEST_WEBHOOK =
  'mock_webhook_simulator_test_webhook'

// API Webhook Errors module
export const API_WEBHOOK_ERRORS_PAGE_LOAD = 'api_webhook_errors_page_load'
export const API_WEBHOOK_ERRORS_GET_DETAIL = 'api_webhook_errors_get_detail'
export const API_WEBHOOK_ERRORS_SUBMIT = 'api_webhook_errors_submit'
// Add more as needed for other pages and actions
